/**
 * Los períodos contables como filtro de los reportes (S2-02).
 *
 * Un período de gestión, sea un mes o uno de 4 semanas, se filtra por sus
 * fechas: desde S1 cada asiento está en el período que cubre su fecha, así que
 * el rango del período da exactamente sus asientos. Acá solo se ordenan y se
 * convierten al valor que entiende `MonthRangePicker`.
 */

/** El día AAAA-MM-DD de lo que manda el servidor (texto o fecha en JSON). */
export const diaDe = (v) => String(v || '').slice(0, 10);

/** Del más viejo al más nuevo. */
export function ordenarPeriodos(periodos = []) {
  return [...periodos].sort((a, b) => diaDe(a.fechaInicio).localeCompare(diaDe(b.fechaInicio)));
}

/** El valor del filtro para un período. */
export function valorDePeriodo(p) {
  return { modo: 'periodo', periodoId: p.id, nombre: p.nombre, desde: diaDe(p.fechaInicio), hasta: diaDe(p.fechaFin) };
}

/** El período anterior (`dir` = -1) o el siguiente (+1); null en los bordes. */
export function periodoVecino(periodos, periodoId, dir) {
  const orden = ordenarPeriodos(periodos);
  const i = orden.findIndex(p => p.id === periodoId);
  if (i < 0) return null;
  return orden[i + dir] || null;
}

/** El período que cubre un día AAAA-MM-DD, o null. */
export function periodoQueCubre(periodos, dia) {
  return ordenarPeriodos(periodos).find(p => diaDe(p.fechaInicio) <= dia && dia <= diaDe(p.fechaFin)) || null;
}

/** Hoy en Costa Rica (UTC−6, sin horario de verano). */
export const hoyCR = () => new Date(Date.now() - 6 * 3600e3).toISOString().slice(0, 10);
